import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";

// Main columns configuration
export const evacuationPlanningColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({ viewModal, updateModal, deleteRecord });

  return {
    "Emergency Shelter Locations": [
      {
        title: "Name of Shelter",
        dataIndex: "Name of Shelter",
        key: "name of shelter",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phone number",
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
      },
      {
        title: "State",
        dataIndex: "State",
        key: "state",
      },
      actionColumn,
    ],
    "Go Bag Name": [
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
      },
      {
        title: "Contents",
        dataIndex: "Contents",
        key: "contents",
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
      },
      actionColumn,
    ],
    "Vehicle Information": [
      { title: "Year", dataIndex: "Year", key: "year" },
      { title: "Make", dataIndex: "Make", key: "make" },
      { title: "Model", dataIndex: "Model", key: "model" },
      { title: "Maintenance Status", dataIndex: "Maintenance Status", key: "maintenancestatus" },
      { title: "Notes", dataIndex: "Notes", key: "notes" },
    ],
  };
};

// Usage example in your component:
// const { viewModal, updateModal, deleteRecord } = yourPropsOrContext;
// const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);
